import { Component, OnInit, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-adfs-profiles',
  templateUrl: './adfs-profiles.component.html',
  styleUrls: ['./adfs-profiles.component.scss']
})
export class AdfsProfilesComponent implements OnInit {
  adfsproList: any = [];
  addadfsproapierror: boolean = false;
  noerrorinaddadfspro: boolean = false;
  errorunabletoperform: boolean = false;
  deleteadfsproapierror: boolean = false;
  editadfsroapierror: boolean = false;
  adfsprooriginAdd: any;
  adfsprousertypeAdd: any;
  adfsproredirecturlAdd: any;
  adfsproresourceAdd: any;
  adfsproclientidAdd: any;
  adfsprologouturlAdd: any;
  adfsprooriginUp: any;
  adfsprousertypeUp: any;
  adfsproredirecturlUp: any;
  adfsproresourceUp: any;
  adfsproclientidUp: any;
  adfsprologoutUrlUp: any;
  erroradfsproOrigin: boolean = false;
  erroradfsprousertype: boolean = false;
  erroradfsproredirecturl: boolean = false;
  erroradfsproresource: boolean = false;
  erroradfsproclientid: boolean = false;
  erroradfsprologouturl: boolean = false;
  adfsUserType: any = [];
  originnamesList: any = [];
  usertypeadfsproList: any = [];
  erroradfsproOriginUp: boolean = false;
  erroradfsprousertypeUp: boolean = false;
  erroradfsproredirecturlUp: boolean = false;
  erroradfsproresourceUp: boolean = false;
  erroradfsproclientidUp: boolean = false;
  erroradfsprologouturlUp: boolean = false;
  noerrorinaddadfsproUp: boolean = false;
  profilealreadypresent: boolean = false;
  deleteprofileid: any;
  adfsproprofileId: any;
  adfsprouserType: any;
  adfsproorigin: any;
  adfsproredirectUrl: any;
  adfsprousertypeInput: any;
  adfsprooriginInput: any;
  adfsproresource: any;
  adfsproclientId: any;
  adfsprologoutUrl: any;
  isBackToTopShowBtn: boolean = false;

  constructor(private service: ApifirstService, private modalService: NgbModal) { }
  ngOnInit(): void {
    this.service.getAdfsPro().subscribe((data) => {
      this.adfsproList = data
      this.originnamesList = []
      for (let origin of this.adfsproList) {
        this.originnamesList.push(origin.origin);
      }
    })
    this.adfsUserType = ['STAFF', 'AUTHORIZED']
  }
  /*on click of Add button*/
  addAdfspro(addadfsprofile: any) {
    this.modalService.open(addadfsprofile, { centered: true });
    this.erroradfsproOrigin = false;
    this.erroradfsprousertype = false;
    this.erroradfsproredirecturl = false;
    this.erroradfsproresource = false;
    this.erroradfsproclientid = false;
    this.erroradfsprologouturl = false;
    this.noerrorinaddadfspro = false;
    this.errorunabletoperform = false;
    this.profilealreadypresent = false;
    this.adfsprooriginAdd = '';
    this.adfsprousertypeAdd = '';
    this.adfsproredirecturlAdd = '';
    this.adfsproresourceAdd = '';
    this.adfsproclientidAdd = '';
    this.adfsprologouturlAdd = '';
    this.service.getAdfsPro().subscribe((data) => {
      this.adfsproList = data
      this.originnamesList = []
      for (let origin of this.adfsproList) {
        this.originnamesList.push(origin.origin);
      }
    })
  }
  /*on click of submit button in add popup*/
  setsubmiteditadfsproAdd(adfsprooriginAdd: any, adfsprousertypeAdd: any,
    adfsproredirecturlAdd: any, adfsproresourceAdd: any, adfsproclientidAdd: any,
    adfsprologouturlAdd: any) {
    this.erroradfsproOrigin = false;
    this.erroradfsprousertype = false;
    this.erroradfsproredirecturl = false;
    this.erroradfsproresource = false;
    this.erroradfsproclientid = false;
    this.erroradfsprologouturl = false;
    this.noerrorinaddadfspro = false;
    this.errorunabletoperform = false;
    this.profilealreadypresent = false;
    if (adfsprooriginAdd == null || adfsprooriginAdd == undefined || adfsprooriginAdd == '' ||
      adfsprooriginAdd.length === 0) {
      this.erroradfsproOrigin = true;
    }
    else {
      this.erroradfsproOrigin = false;
    }
    if (adfsprousertypeAdd == null || adfsprousertypeAdd == undefined || adfsprousertypeAdd == '' ||
      adfsprousertypeAdd.length === 0) {
      this.erroradfsprousertype = true;
    }
    else {
      this.erroradfsprousertype = false;
    }
    if (adfsproredirecturlAdd == null || adfsproredirecturlAdd == undefined || adfsproredirecturlAdd == '' ||
      adfsproredirecturlAdd.length === 0) {
      this.erroradfsproredirecturl = true;
    }
    else {
      this.erroradfsproredirecturl = false;
    }
    if (adfsproresourceAdd == null || adfsproresourceAdd == undefined || adfsproresourceAdd == '' ||
      adfsproresourceAdd.length === 0) {
      this.erroradfsproresource = true;
    }
    else {
      this.erroradfsproresource = false;
    }
    if (adfsproclientidAdd == null || adfsproclientidAdd == undefined || adfsproclientidAdd == '' ||
      adfsproclientidAdd.length === 0) {
      this.erroradfsproclientid = true;
    }
    else {
      this.erroradfsproclientid = false;
    }
    if (adfsprologouturlAdd == null || adfsprologouturlAdd == undefined || adfsprologouturlAdd == '' ||
      adfsprologouturlAdd.length === 0) {
      this.erroradfsprologouturl = true;
    }
    else {
      this.erroradfsprologouturl = false;
    }
    if (this.originnamesList.includes(adfsprooriginAdd)) {
      this.usertypeadfsproList = []
      for (let utype of this.adfsproList) {
        if (utype.origin == adfsprooriginAdd) {
          this.usertypeadfsproList.push(utype.userType);
        }
      }
      if (this.usertypeadfsproList.includes(adfsprousertypeAdd)) {
        this.profilealreadypresent = true;
      }
      else {
        this.profilealreadypresent = false;
      }
    }
    else {
      this.profilealreadypresent = false;
    }
    if (this.erroradfsproOrigin == false && this.erroradfsprousertype == false &&
      this.erroradfsproredirecturl == false && this.erroradfsproresource == false &&
      this.erroradfsproclientid == false && this.erroradfsprologouturl == false &&
      this.profilealreadypresent == false) {
      this.noerrorinaddadfspro = true;
      this.errorunabletoperform = false;
    }
    else {
      this.noerrorinaddadfspro = false;
      if (this.profilealreadypresent == true) {
        this.errorunabletoperform = false;
      }
      else {
        this.errorunabletoperform = true;
      }
    }
    let req = {
      "origin": adfsprooriginAdd,
      "userType": adfsprousertypeAdd,
      "redirectUrl": adfsproredirecturlAdd,
      "resource": adfsproresourceAdd,
      "clientId": adfsproclientidAdd,
      "logoutUrl": adfsprologouturlAdd
    }
    if (this.noerrorinaddadfspro == true) {
      this.service.addAdfsPro(req).subscribe((data) => {
        this.addadfsproapierror = false;
        this.service.getAdfsPro().subscribe((data) => {
          this.adfsproList = data
          this.originnamesList = []
          for (let origin of this.adfsproList) {
            this.originnamesList.push(origin.origin);
          }
        })
        this.modalService.dismissAll(true);
      }, (error) => {
        this.addadfsproapierror = true;
      });
    }
  }
  /*on click of delete buton*/
  deleteAdfsprodata(id: any, deletePopUpAdfspro: any) {
    this.modalService.open(deletePopUpAdfspro, { centered: true });
    this.deleteprofileid = id;
  }
  /*on click of delete button in delete popup*/
  deletePopcredentialAdfspro() {
    this.service.deleteAdfsPro(this.deleteprofileid).subscribe((data) => {
      this.deleteadfsproapierror = false;
      this.service.getAdfsPro().subscribe((data) => {
        this.adfsproList = data
        this.originnamesList = []
        for (let origin of this.adfsproList) {
          this.originnamesList.push(origin.origin);
        }
      })
    }, (error) => {
      this.deleteadfsproapierror = true;
    });
  }
  /*on click of edit button*/
  editAdfsprodata(profileId: any, origin: any, userType: any,
    redirectUrl: any, resource: any, clientId: any, logoutUrl: any, editAdfsproCredentials: any) {
    this.modalService.open(editAdfsproCredentials, { centered: true });
    this.adfsproprofileId = profileId;
    this.adfsprooriginUp = origin;
    this.adfsprooriginInput = origin;
    this.adfsprousertypeUp = userType;
    this.adfsprousertypeInput = userType;
    this.adfsproredirecturlUp = redirectUrl;
    this.adfsproresourceUp = resource;
    this.adfsproclientidUp = clientId;
    this.adfsprologoutUrlUp = logoutUrl;
  }
  /*on click of submit button in edit popup*/
  setsubmiteditadfsproedit(adfsprooriginUp: any, adfsprousertypeUp: any, adfsproredirecturlUp: any,
    adfsproresourceUp: any, erroradfsproclientidUp: any, adfsprologouturlUp: any) {
    this.erroradfsproOriginUp = false;
    this.erroradfsprousertypeUp = false;
    this.erroradfsproredirecturlUp = false;
    this.erroradfsproresourceUp = false;
    this.erroradfsproclientidUp = false;
    this.erroradfsprologouturlUp = false;
    this.noerrorinaddadfsproUp = false;
    this.profilealreadypresent = false;
    this.usertypeadfsproList = []
    for (let names of this.adfsproList) {
      if (names.origin == adfsprooriginUp) {
        this.usertypeadfsproList.push(names.userType);
      }
    }
    if (this.usertypeadfsproList.includes(adfsprousertypeUp) &&
      (this.originnamesList.includes(adfsprooriginUp))) {
      if (this.adfsprousertypeInput != adfsprousertypeUp ||
        this.adfsprooriginInput != adfsprooriginUp) {
        this.profilealreadypresent = true;
      }
    }
    else {
      this.profilealreadypresent = false;
    }
    if (adfsprooriginUp == null || adfsprooriginUp == undefined || adfsprooriginUp == '' ||
    adfsprooriginUp.length === 0) {
      this.erroradfsproOriginUp = true;
    }
    else {
      this.erroradfsproOriginUp = false;
    }
    if (adfsprousertypeUp == null || adfsprousertypeUp == undefined || adfsprousertypeUp == '' ||
      adfsprousertypeUp.length === 0) {
      this.erroradfsprousertypeUp = true;
    }
    else {
      this.erroradfsprousertypeUp = false;
    }
    if (adfsproredirecturlUp == null || adfsproredirecturlUp == undefined || adfsproredirecturlUp == '' ||
      adfsproredirecturlUp.length === 0) {
      this.erroradfsproredirecturlUp = true;
    }
    else {
      this.erroradfsproredirecturlUp = false;
    }
    if (adfsproresourceUp == null || adfsproresourceUp == undefined || adfsproresourceUp == '' ||
      adfsproresourceUp.length === 0) {
      this.erroradfsproresourceUp = true;
    }
    else {
      this.erroradfsproresourceUp = false;
    }
    if (erroradfsproclientidUp == null || erroradfsproclientidUp == undefined || erroradfsproclientidUp == '' ||
      erroradfsproclientidUp.length === 0) {
      this.erroradfsproclientidUp = true;
    }
    else {
      this.erroradfsproclientidUp = false;
    }
    if (adfsprologouturlUp == null || adfsprologouturlUp == undefined || adfsprologouturlUp == '' ||
      adfsprologouturlUp.length === 0) {
      this.erroradfsprologouturlUp = true;
    }
    else {
      this.erroradfsprologouturlUp = false;
    }
    if (this.erroradfsprousertypeUp == false && this.erroradfsproOriginUp == false &&
      this.erroradfsproredirecturlUp == false && this.erroradfsproresourceUp == false &&
      this.erroradfsproclientidUp == false && this.erroradfsprologouturlUp == false &&
      this.profilealreadypresent == false) {
      this.noerrorinaddadfsproUp = true;
    }
    else {
      this.noerrorinaddadfsproUp = false;
      if (this.profilealreadypresent == true) {
        this.errorunabletoperform = false;
      }
      else {
        this.errorunabletoperform = true;
      }
    }

    let req = {
      "origin": adfsprooriginUp,
      "userType": adfsprousertypeUp,
      "redirectUrl": adfsproredirecturlUp,
      "resource": adfsproresourceUp,
      "clientId": erroradfsproclientidUp,
      "logoutUrl": adfsprologouturlUp
    }
    if (this.noerrorinaddadfsproUp == true) {
      this.service.editAdfsPro(this.adfsproprofileId, req).subscribe((data) => {
        this.editadfsroapierror = false;
        this.service.getAdfsPro().subscribe((data) => {
          this.adfsproList = data
          this.originnamesList = []
          for (let origin of this.adfsproList) {
            this.originnamesList.push(origin.origin);
          }
        })
        this.modalService.dismissAll(true);
      }, (error) => {
        this.editadfsroapierror = true;
      });
    }
  }
  clearVariablesAdfspro() {
    this.addadfsproapierror = false;
    this.deleteadfsproapierror = false;
    this.erroradfsproOrigin = false;
    this.erroradfsprousertype = false;
    this.erroradfsproredirecturl = false;
    this.erroradfsproresource = false;
    this.erroradfsproclientid = false;
    this.erroradfsprologouturl = false;
    this.noerrorinaddadfspro = false;
    this.errorunabletoperform = false;
    this.profilealreadypresent = false;
    this.editadfsroapierror = false;
    this.erroradfsproOriginUp = false;
    this.erroradfsprousertypeUp = false;
    this.erroradfsproredirecturlUp = false;
    this.erroradfsproresourceUp = false;
    this.erroradfsproclientidUp = false;
    this.erroradfsprologouturlUp = false;
    this.noerrorinaddadfsproUp = false;
  }


  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
}
